import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var dealStr = function dealStr(img) {
  var isBreak = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return "<div style=\"page-break-after: auto; page-break-before: auto;page-break-inside: auto\"><img style=\"box-sizing: border-box; margin: 0 auto;width: 100vw; height: ".concat(!isBreak ? 98 : 100, "vh;\" src=\"").concat(img, "\"/></div>");
};

import html2canvas from 'html2canvas';
import * as cloneDeep from 'lodash/cloneDeep';
export default {
  data: function data() {
    return {
      qr: {
        id: 'canvas',
        dom: null,
        width: 200,
        height: 300,
        scale: 5
      },
      printData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initCanvas();
    });
  },
  methods: {
    initCanvas: function initCanvas() {
      var canvas = document.getElementById(this.qr.id);
      this.$set(this.qr, 'dom', canvas);
    },
    handlePrint: function handlePrint(data, n) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.printData = cloneDeep(data);
                return _context2.abrupt("return", new Promise(function (resl, reje) {
                  _this2.$nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var str;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            str = '';
                            _context.next = 3;
                            return _this2.setPage();

                          case 3:
                            str = _context.sent;
                            resl(dealStr(str, n > 1));

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  })));
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    setPage: function setPage() {
      var _this$qr = this.qr,
          dom = _this$qr.dom,
          width = _this$qr.width,
          height = _this$qr.height,
          scale = _this$qr.scale;
      var options = {
        width: width * scale,
        height: height * scale,
        backgroundColor: '#ffffff'
      };
      return new Promise(function (resl, reje) {
        html2canvas(dom, options).then(function (canvas) {
          var base64 = canvas.toDataURL();
          resl(base64);
        });
      });
    }
  }
};